/* © 2022 Prometheanexport const  All Rights Reservedexport const
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibitedexport const
 */

export var PROMETHEAN_NO_SHADOW = {
  boxShadow: 'none'
};
export var PROMETHEAN_INNER_SHADOW = {
  boxShadow: 'inset 0.5px 0.5px 1px rgba(0, 0, 0, 0.2)'
};
export var PROMETHEAN_LIGHT_SHADOW = {
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)'
};
export var PROMETHEAN_MEDIUM_SHADOW = {
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)'
};
export var PROMETHEAN_HEAVY_SHADOW = {
  boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.25)'
};
export var PROMETHEAN_HEAVY_SHADOW_UP = {
  boxShadow: '0px -3px 12px rgba(0, 0, 0, 0.25)'
};